import React, {useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'

import {viewData} from '../plan-list/core/_requests'
import {EditEmployee} from './Edit'

export const EditWrapper = () => {
  const {id} = useParams()
  const [data, setData] = useState<any>(null)
  useEffect(() => {
    viewData(id).then((res) => {
      
      setData(res.Data)
    })
  }, [])
  if (data) {
    return <EditEmployee initialValues={data} />
  }
  return null
}
